<template>
  <DocumentEditor
    v-if="!loading"
    v-model="document"
    :fields="fields"
    :performDocumentSave="saveDocument"
  />
</template>

<script>
import DocumentEditor from "@/components/ri3/documents/DocumentEditor.vue"
import { DocumentService } from "@/services/documents"
import { InspectionService } from "@/services"
import { mkDocument } from "@/utils/datamodels"

export default {
  name: "InspectionDocumentEditor",
  components: { DocumentEditor },
  props: {
    inspection: {
      type: Object,
      required: true
    }
  },
  created() {
    this.fetchDocument()
  },
  computed: {
    fields() {
      return { name: false, project: false, template: this.isNew }
    }
  },
  data() {
    return {
      isNew: false,
      document: undefined,
      loading: true
    }
  },
  methods: {
    // Load document using inspection or use defaultDocument if invalid
    async fetchDocument() {
      this.loading = true
      InspectionService.document
        .get(this, this.inspection.id)
        .then(response => {
          this.isNew = false
          this.document = response
        })
        .catch(error => {
          // load default document
          this.isNew = true
          this.document = {
            ...mkDocument(),
            name: this.inspection.name,
            project: this.$store.state.app.project
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // Custommize document save
    saveDocument(document) {
      return document.id > 0
        ? DocumentService.put(document)
        : InspectionService.document.post(this.inspection.id, document)
    }
  }
}
</script>
